import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useTheme } from '@material-ui/core'
import { useStyles } from '../styles'
import { useVaultContext } from '../../VaultContextProvider'
import { defaultDocumentDetailsLabel } from '../../constants'
import Tag from '../../../../atoms/Tag'

export const DocumentDetailTagsBlock = ({
  document
}) => {
  const theme = useTheme()
  const classes = useStyles()
  const { labels } = useVaultContext()

  return (
    <div className={classes.detailsBlock}>
      <div className={classes.detailBlockTitle}>
        {labels?.documentDetails?.tags ?? defaultDocumentDetailsLabel.tags}
      </div>

      <div className={clsx([classes.detailBlockContent, classes.tagContent])}>
        {document.tags.map(tag => (
          <Tag
            key={tag}
            label={tag.name}
            backgroundColor={tag.colorField ?? 'var(--color-primary-500)'}
            color={tag.colorField ? theme.palette.getContrastText(tag.colorField) : 'var(--color-contrast-primary-500)'}
          />
        ))}
      </div>
    </div>
  )
}

DocumentDetailTagsBlock.propTypes = {
  document: PropTypes.object.isRequired
}
